import { useState } from "react";
import { ChatImageViewer } from "common/elements";
import { btnDelay, usePlaySound } from "common/utils";

export const ChatMessageImage = ({ url }: { url: string }) => {
  const play = usePlaySound();
  const [preview, setPreview] = useState(false);

  const handleOpen = () => {
    btnDelay(() => {
      play();
      setPreview(true);
    });
  };

  return (
    <>
      <img src={url} className="max-w-[200px] h-auto cursor-pointer" onClick={handleOpen} />
      <ChatImageViewer visible={preview} url={url} close={() => setPreview(false)} />
    </>
  );
};
